/** @file fillSlotImage: uploads one PNG and fills one slot with it (one batch), then refreshes the preview. */
import type { EditorStore } from '../../../state/editorTypes';
import type { ArtDeps, FitMode } from '../artTypes';

const messageOf = (e: unknown): string => (e instanceof Error ? e.message : String(e));

/**
 * `deps.uploadImage`, then `slot.fill { slot, image, fit? }` alone in a batch labelled `label` (the server adapts a
 * misfit with `fit`). True when it landed; an upload error or a refused batch becomes an error toast (false).
 */
export async function fillSlotImage(store: EditorStore, deps: Pick<ArtDeps, 'uploadImage'>, slot: string, png: Uint8Array, fit: FitMode | undefined, label: string): Promise<boolean> {
  const puppetId = store.getState().puppet.id;
  if (puppetId === null) return false;
  try {
    const image = (await deps.uploadImage(puppetId, png)).id;
    const replies = await store.getState().dispatch([{ name: 'slot.fill', input: fit === undefined ? { slot, image } : { slot, image, fit } }], label);
    const bad = replies.find((r) => !r.ok);
    if (bad?.ok === false) throw new Error(bad.error.message);
  } catch (e) {
    store.getState().notify('error', `${label}: ${messageOf(e)}`);
    return false;
  }
  await store.getState().refreshLint();
  await store.getState().refreshPreview();
  return true;
}
